import { render, staticRenderFns } from "./dictionarylist.vue?vue&type=template&id=eabb6a50&"
import script from "./dictionarylist.vue?vue&type=script&lang=js&"
export * from "./dictionarylist.vue?vue&type=script&lang=js&"
import style0 from "./dictionarylist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports